/* This file was generated automatically. Do not edit manually. */

export enum PayoutDetailResultType {
    Charge = 'Charge',
    CommissionAdjustment = 'CommissionAdjustment',
    Refund = 'Refund',
    ChargeBack = 'ChargeBack',
    ChargebackReversal = 'ChargebackReversal',
    PlatformFee = 'PlatformFee',
    BalanceTopUp = 'BalanceTopUp',
    Payout = 'Payout',
}
